import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Restaumatic$dMenu$dPromotions from "../Restaumatic.Menu.Promotions/index.js";
const $PromotionsResponse = (tag, _1) => ({tag, _1});
const fromFoldable = /* #__PURE__ */ Data$dMap$dInternal.fromFoldable(Data$dOrd.ordInt)(Data$dFoldable.foldableArray);
const Promotions = value0 => $PromotionsResponse("Promotions", value0);
const InvalidCoupon = /* #__PURE__ */ $PromotionsResponse("InvalidCoupon");
const NetworkError = /* #__PURE__ */ $PromotionsResponse("NetworkError");
const decodeResponse = v => {
  if (v.tag === "Right") {
    if (v._1.tag === "Right") {
      return $PromotionsResponse(
        "Promotions",
        {
          promotions: fromFoldable(Data$dFunctor.arrayMap(Restaumatic$dMenu$dPromotions.withPromotionId)(Data$dRecord.unsafeGet("promotions")(v._1._1))),
          coupons: Data$dRecord.unsafeGet("coupons")(v._1._1)
        }
      );
    }
    if (v._1.tag === "Left") { return InvalidCoupon; }
    return NetworkError;
  }
  return NetworkError;
};
const getActivePromotionsAndDecode = restaurantId => menuConsumer => enteredCouponCodes => promotionsBackend => Effect$dAff._map(decodeResponse)(promotionsBackend.getActivePromotions(menuConsumer)({
  restaurantId,
  couponCodes: Data$dFunctor.arrayMap(Data$dString$dCommon.trim)(enteredCouponCodes)
}));
export {$PromotionsResponse, InvalidCoupon, NetworkError, Promotions, decodeResponse, fromFoldable, getActivePromotionsAndDecode};
